const listFormatters = new Map<string, Intl.ListFormat>();

type FormatListOptions = 'conjunction' | 'unit' | 'disjunction';

const getListFormatter = (
  locale: string,
  type: FormatListOptions,
): Intl.ListFormat | null => {
  const cached = listFormatters.get(`${locale}-${type}`);
  if (cached) {
    return cached;
  }

  try {
    const formatter = new Intl.ListFormat(locale, {
      type: type,
    });
    listFormatters.set(`${locale}-${type}`, formatter);
    return formatter;
  } catch {
    return null;
  }
};

export const formatList = (
  items: string[],
  locale: string,
  type: FormatListOptions = 'conjunction',
): string => {
  const formatter =
    getListFormatter(locale, type)
      ?.formatToParts(['dummy', 'dummy', 'dummy'])
      .find((part) => part.type === 'literal')?.value ?? ', ';
  return formatter ? items.join(formatter) : items.join(', ');
};
